import type {
  PostDocumentAttachmentRequestType,
  PostDocumentAttachmentResponseType,
} from 'entities/document/api/types';
import { changeDateToStringInObject } from 'helpers/safeJsonStringify';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postDocumentAttachment = async (
  params: PostDocumentAttachmentRequestType,
) => {
  const { documentId, data, ...rest } = params;
  const url = `/api/v2/documents/${documentId}/attachments`;
  const response = await apiAuthClient.post<PostDocumentAttachmentResponseType>(
    url,
    {
      ...rest,
      data:
        data && typeof data === 'object'
          ? changeDateToStringInObject(data)
          : data,
    },
  );

  return response.data;
};
